import React from 'react'
import MenuItem from 'material-ui/MenuItem'
import config from '../../config'
import duplicatePage from './duplicate-page'

const buildMenuItems = (resource) => [
  <MenuItem primaryText='Edit' key='edit' value={`/cms/pages/${resource.id}/edit`} />,
  <MenuItem key='View Page'>
    <a
      style={{ color: 'inherit', textDecoration: 'none' }}
      href={`${config.webUrl}${resource.slug}`}
      target='_blank' rel="noreferrer"
    >
      View Page
    </a>
  </MenuItem>,
  <MenuItem key='Duplicate Page' onClick={() => duplicatePage(resource)}>
    Duplicate Page
  </MenuItem>
]

export default buildMenuItems
